import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    thkMemberAppUrl: string;
    enableThkMemberAppRedirection: boolean;
};

type HandlerType = Handler<Parameter>;

const DispatchSetMemberAppConfig: HandlerType = props => {
    props.dispatch({
        type: "Components/MemberAppConfig/SetConfig",
        parameter: {
            thkMemberAppUrl: props.parameter.thkMemberAppUrl,
            enableThkMemberAppRedirection: props.parameter.enableThkMemberAppRedirection,
        },
    });
};

const chain = [DispatchSetMemberAppConfig];

const setMemberAppConfig = createHandlerChainRunner(chain, "SetMemberAppConfig");
export default setMemberAppConfig;
